import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { getAppConfig } from '@/config'
import enUS from '@99fun-agent/i18n/src/I18N/en-US'
import zhCN from '@99fun-agent/i18n/src/I18N/zh-CN'
import idID from '@99fun-agent/i18n/src/I18N/id-ID'
import thTH from '@99fun-agent/i18n/src/I18N/th-TH'
import urPK from '@99fun-agent/i18n/src/I18N/ur-PK'
import viVN from '@99fun-agent/i18n/src/I18N/vi-VN'
import myMM from '@99fun-agent/i18n/src/I18N/my-MM'

/**
 * i18n Installer
 * 初始化国际化支持
 */
export const installI18n = (app: App) => {
  const config = getAppConfig()

  const defaultLocale = config.defaultLang || 'en-US'
  const defaultMessages = {
    'en-US': enUS,
    'zh-CN': zhCN,
    'id-ID': idID,
    'th-TH': thTH,
    'ur-PK': urPK,
    'vi-VN': viVN,
    'my-MM': myMM,
  }

  const i18n = createI18n({
    legacy: false, // 使用 Composition API 模式
    locale: defaultLocale, // 使用计算出的初始语言
    fallbackLocale: 'en-US', // 回退语言
    messages: defaultMessages,
    globalInjection: true,
  })
  console.log('i18n init')
  app.use(i18n)

  return i18n
}
